import { AppTable } from 'shared/UI/UIKit/Table';
import { AppButton } from 'shared/UI/UIKit/Button';
import { useTableService } from '../model';

interface CalendarTableProps {
  selectedTab?: string;
}

export const CalendarTable = ({ selectedTab }: CalendarTableProps) => {
  const {
    state: { periods, loading, columns, saveIsLoading, saveIsDisabled },
    methods: { handleAddRow, handleSave },
  } = useTableService({ calendarId: selectedTab });

  return (
    <>
      <AppTable
        columns={columns}
        dataSource={periods}
        rowKey={(record) => record.id}
        loading={loading}
      />

      <div style={{ marginTop: 16, display: 'flex', gap: 8 }}>
        <AppButton onClick={handleAddRow} type="outline">
          Добавить период
        </AppButton>
        <AppButton
          type="primary"
          onClick={handleSave}
          loading={saveIsLoading}
          disabled={saveIsDisabled}
        >
          Сохранить
        </AppButton>
      </div>
    </>
  );
};
